import { memo, useEffect } from "react";
import { Span } from "../../../../components/Text/Text";
import { clientTypesSO } from "../../../../utils/helpers/selectOptions";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../../../utils/hooks/useAuth";
import {
  AccessLevelE,
  ClientTypeE,
  IconColorE,
  UserRoleE,
} from "../../../../models/enums";
import Icon from "../../../../components/Icon/Icon";
import { RoutesE } from "../../../../routes/routesData";
import WhatsappHelp from "../../../../components/WhatsappHelp/WhatsappHelp";
import { useNonDesktopViewport } from "../../../../utils/hooks/useNonDesktopViewport";

import styles from "./styles.module.scss";
import AccessRights from "../../../../components/AccessRights/AccessRights";

interface SupportSidebarI {
  isFetchingVideoGuides?: boolean;
}

const SupportSidebar = memo((props: SupportSidebarI) => {
  const { isFetchingVideoGuides } = props;
  const isNonDesktop = useNonDesktopViewport();
  const navigate = useNavigate();
  const { hash, pathname } = useLocation();
  const { currentUser } = useAuth();

  const goToClientVideoGuides = (clientType) => {
    const clientTypeElement = document.getElementById(
      clientType + "-client-type"
    );
    if (pathname.includes("videoguides")) {
      if (clientTypeElement) {
        clientTypeElement.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  const goToTechnicalInstruction = (technicalInstruction: string) => {
    const technicalInstructionElement =
      document.getElementById(technicalInstruction);
    if (pathname.includes("technicalinstruction")) {
      if (technicalInstructionElement) {
        technicalInstructionElement.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  // // Scroll to the client type element when the page is loaded
  // useEffect(() => {
  //   if (pathname.includes("videoguides") && !isFetchingVideoGuides) {
  //     if (hash) {
  //       const clientTypeElement = document.getElementById(
  //         hash.replace("#", "")
  //       );
  //       if (clientTypeElement) {
  //         // Scroll with offset
  //         clientTypeElement.scrollIntoView({
  //           behavior: "smooth",
  //         });
  //       }
  //       // If the user is logged in, scroll to the client type element
  //     } else if (
  //       currentUser &&
  //       currentUser.accessLevel !== AccessLevelE.GlobalAdmin &&
  //       currentUser.accessLevel !== AccessLevelE.DeliveryServicePrivate
  //     ) {
  //       goToClientVideoGuides(currentUser.clientType);
  //       navigate(`#${currentUser.clientType}-client-type`);
  //     } else if (
  //       currentUser &&
  //       currentUser.accessLevel === AccessLevelE.DeliveryServicePrivate
  //     ) {
  //       goToClientVideoGuides(ClientTypeE["Delivery service"]);
  //       navigate(`#${ClientTypeE["Delivery service"]}-client-type`);
  //     }
  //   }
  // }, [currentUser, isFetchingVideoGuides]);

  return (
    <div className={styles.supportSidebarWrapper}>
      <ul className={styles.topMenu}>
        <li className={pathname.includes("videoguides") ? styles.active : ""}>
          <Icon
            name="video"
            color={
              pathname.includes("videoguides")
                ? IconColorE.BLUE
                : IconColorE.WHITE
            }
          />
          <NavLink
            to={RoutesE.SUPPORT_VIDEO_GUIDES}
            className={pathname.includes("videoguides") ? styles.active : ""}
          >
            <Span>Video Guides</Span>
          </NavLink>
        </li>
        {/* <ul className={styles.nestedMenu}>
          {clientTypesSO
            .filter(
              (ct) =>
                ct.value !== ClientTypeE["Radio station"] &&
                ct.value !== ClientTypeE["Production company"]
            )
            .map((clientType, index) => (
              <li key={index}>
                <NavLink
                  to={
                    pathname.includes("videoguides")
                      ? `#${clientType.value}-client-type`
                      : `/home/support/videoguides#${clientType.value}-client-type`
                  }
                  onClick={() => goToClientVideoGuides(clientType.value)}
                  className={
                    hash === `#${clientType.value}-client-type`
                      ? styles.active
                      : ""
                  }
                >
                  <Span>{clientType.label}</Span>
                </NavLink>
              </li>
            ))}
        </ul> */}
        <li
          className={
            pathname.includes("technicalinstruction") ? styles.active : ""
          }
        >
          <Icon
            name="wrench"
            color={
              pathname.includes("technicalinstruction")
                ? IconColorE.BLUE
                : IconColorE.WHITE
            }
          />
          <NavLink
            to={RoutesE.SUPPORT_TECHNICAL_INSTRUCTION + "#before-you-start"}
            className={
              pathname.includes("technicalinstruction") ? styles.active : ""
            }
          >
            <Span>Technical Instruction</Span>
          </NavLink>
        </li>
        <ul className={styles.nestedMenu}>
          <li>
            <NavLink
              to="/home/support/technicalinstruction#before-you-start"
              onClick={() => goToTechnicalInstruction("before-you-start")}
              className={hash === `#before-you-start` ? styles.active : ""}
            >
              <Span>Before you start</Span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/home/support/technicalinstruction#video-requirement"
              onClick={() => goToTechnicalInstruction("video-requirement")}
              className={hash === `#video-requirement` ? styles.active : ""}
            >
              <Span>Video requirement</Span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/home/support/technicalinstruction#export-files"
              onClick={() => goToTechnicalInstruction("export-files")}
              className={hash === `#export-files` ? styles.active : ""}
            >
              <Span>Export files</Span>
            </NavLink>
          </li>
        </ul>
        <li>
          <NavLink
            to={"/home/support/contactus"}
            className={`${styles.contactUsLink} ${
              pathname.includes("contactus") ? styles.active : ""
            }`}
          >
            <Icon
              name="phone"
              color={
                pathname.includes("contactus")
                  ? IconColorE.BLUE
                  : IconColorE.WHITE
              }
            />
            <Span>Contact Us</Span>
          </NavLink>
        </li>
        <AccessRights accessFor={[UserRoleE.PostProduction, UserRoleE.DeliveryService]}>
          <li>
            <NavLink
              to={"/home/support/pricecalc"}
              className={`${
                pathname.includes("pricecalc") ? styles.active : ""
              }`}
            >
              <Icon
                name="calc"
                color={
                  pathname.includes("pricecalc")
                    ? IconColorE.BLUE
                    : IconColorE.WHITE
                }
                className={styles.calcIcon}
              />
              <Span>Price Calculator</Span>
            </NavLink>
          </li>
        </AccessRights>
      </ul>
      {/* {!isNonDesktop && <WhatsappHelp />} */}
    </div>
  );
});

export default SupportSidebar;
